module.exports = __webpack_public_path__ + "static/media/station.eed1723a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/station.png
// module id = 1290
// module chunks = 0